import { useMemo } from 'react';
import styled from 'styled-components';
import { useScrollY } from '../../../../hooks/screen/useScrollY';
import { Icon } from '../../icon/Icon';

interface BottomFloationButtonProps {
  handleButtonClick: () => void;
  title: string;
}

export const BottomFloatingButton = ({ handleButtonClick, title }: BottomFloationButtonProps) => {
  const { scrollY } = useScrollY();

  const isOnTop = useMemo<boolean>(() => {
    if (scrollY > 0) {
      return false;
    }

    return true;
  }, [scrollY]);
  return (
    <FloatingButtonWrapper>
      <Button isCollapsed={!isOnTop} onClick={handleButtonClick}>
        <Icon name={'Plus2'} width={isOnTop ? 14 : 20} height={isOnTop ? 14 : 20} />
        <ButtonText isCollapsed={!isOnTop}>{title}</ButtonText>
      </Button>
    </FloatingButtonWrapper>
  );
};

const FloatingButtonWrapper = styled.div`
  width: 100%;
  position: absolute;
  top: 0px;
`;

const Button = styled.button<{ isCollapsed: boolean }>`
  height: 52px;

  display: flex;
  align-items: center;

  position: absolute;

  bottom: 16px;
  right: 16px;

  padding: var(--radius-large, 16px);

  gap: ${(props) => (props.isCollapsed ? '0px' : '8px')};

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const ButtonText = styled.span<{ isCollapsed: boolean }>`
  max-width: ${(props) => (props.isCollapsed ? '0px' : '150px')};

  display: -webkit-box;
  max-height: 42px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  overflow: hidden;
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 13.6px */

  transition-property: max-width;
  transition-duration: 0.1s;
  transition-timing-function: ease-in-out;
`;
